/**
 * @file Les 13 grades d'armes (D..ZZZ) : index, couleurs (primaire/secondaire/halo), intensite de lueur, scintillement.
 */
import { GRADES } from '@shared/enums';
import type { GradeId } from '@shared/enums';
import type { GradeDef } from './types';

const g = (
  id: GradeId,
  primary: string,
  secondary: string,
  glowColor: string,
  glow: number,
  shimmer = false,
): GradeDef => ({ id, index: GRADES.indexOf(id), colors: { primary, secondary, glow: glowColor }, glow, shimmer });

/** Couleurs : D..XXX d'apres la feuille d'origine ; Z/ZZ/ZZZ definies ici (non decrites dans l'original). */
export const GRADE_DEFS: readonly GradeDef[] = [
  g('D', '#d6dae0', '#aab2bf', '#ffffff', 0.0), // gris clair
  g('C', '#b07d4f', '#cfd6df', '#e8c9a0', 0.0), // bois brun + corps argente
  g('B', '#4f93e8', '#eef3fa', '#9cc8ff', 0.1), // bleu + gris clair/blanc
  g('A', '#5bbf6e', '#cdd5dd', '#a7f0b5', 0.15), // vert + argent
  g('S', '#f4c64e', '#fff8e8', '#ffe9a0', 0.3), // or + blanc
  g('SS', '#e5525f', '#f4c64e', '#ff9aa3', 0.4), // rouge + or
  g('SSS', '#9b6fe3', '#f4c64e', '#d3b8ff', 0.5), // violet + or
  g('X', '#2fc9c1', '#dce3ea', '#9ffcf5', 0.55), // turquoise + argent
  g('XX', '#2b2b38', '#d3314c', '#ff6b84', 0.65), // noir + carmin
  g('XXX', '#223f86', '#f4c64e', '#7fa4ff', 0.75), // bleu marine + or
  g('Z', '#ff8fb8', '#7fe9ff', '#ffd1e6', 0.85, true), // prisme pastel rose/cyan
  g('ZZ', '#f6f1ff', '#9d8cff', '#c9bfff', 0.95, true), // nacre iridescente
  g('ZZZ', '#150b33', '#ffd45e', '#ff9bff', 1.0, true), // cosmique : nuit profonde + or + magenta
];

export const GRADE_BY_ID: ReadonlyMap<GradeId, GradeDef> = new Map(GRADE_DEFS.map((d) => [d.id, d]));

export const getGradeDef = (id: GradeId): GradeDef => {
  const d = GRADE_BY_ID.get(id);
  if (!d) throw new Error(`Unknown grade: ${id}`);
  return d;
};

export const nextGrade = (id: GradeId): GradeId | null => {
  const i = GRADES.indexOf(id);
  return i >= 0 && i < GRADES.length - 1 ? (GRADES[i + 1] as GradeId) : null;
};
